<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_endereco && rowData.pessoa_endereco.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t2' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Endereço
              <i class="fa fa-home"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_contato_email && rowData.pessoa_contato_email.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t3' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Email
              <i class="fa fa-envelope"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_contato_tel && rowData.pessoa_contato_tel.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t4' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Telefone
              <i class="fa fa-phone"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_financeiro && rowData.pessoa_financeiro.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t5' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Financeiro
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.regra_fiscal_cliente && rowData.regra_fiscal_cliente.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t6' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Regra Fiscal
              <i class="fa fa-list"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_fisica && rowData.pessoa_fisica.pessoa_motorista">
          <a
            class="nav-link"
            v-bind:href="'#t7' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Dados Motorista
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_referencia && rowData.pessoa_referencia.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t8' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Referências
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t9' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Configurações
              <i class="fa fa-cogs"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_ajudante">
          <a
            class="nav-link"
            v-bind:href="'#t10' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes do Ajudante
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t11' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ger. Risco
              <i class="fa fa-info-circle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t12' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Erros Ger. Risco
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_foto && rowData.pessoa_ajudante.pessoa_ajudante_foto.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t13' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Foto do documento
              <i class="fa fa-picture-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item" v-if="rowData && rowData.integracao_log && rowData.integracao_log.length > 0">
          <a
            class="nav-link"
            v-bind:href="'#t15' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Status Integração
              <i class="fa fa-cogs"></i>
            </span>
          </a>
        </li>
      </ul>


      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th>Tipo Pessoa</th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Nacionalidade
                </th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Ocupação
                </th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Estado Civil
                </th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Relacionamento
                </th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Nome pai
                </th>
                <th v-if="rowData && rowData.pessoa_fisica">
                  Nome mãe
                </th>
                <th v-if="rowData && rowData.pessoa_juridica">
                  Nome Fantasia
                </th>
                <th v-if="rowData && rowData.pessoa_juridica">
                  Inscrição Municipal
                </th>
                <th v-if="rowData && rowData.pessoa_juridica">
                  Inscrição Suframa
                </th>
                <th v-if="rowData && rowData.pessoa_juridica">
                  CD Regime Tributário
                </th>
                <th>Tipo Cadastro</th>
                <th>Observação</th>
                <th>VIP Nacional</th>
                <th>VIP Internacional</th>
                <th>CNAE</th>
                <th>Ind. IE</th>
                <th>Tipo Proprietario</th>
                <th>Tipo Fornecedor</th>
                <th>Exige averbação?</th>
                <th>Valida Opentech</th>
                <th>Num. ANTT</th>
                <th>Validade ANTT</th>
                <th v-if="rowData && rowData.pessoa_juridica">
                  Código gestão de pagamento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData && rowData.liv_tipo_pessoa ? rowData.liv_tipo_pessoa.descr : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.param_nacionalidade ? rowData.pessoa_fisica.param_nacionalidade.descr : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.param_ocupacao ? rowData.pessoa_fisica.param_ocupacao.descr : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.param_estado_civil ? rowData.pessoa_fisica.param_estado_civil.descr : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.param_relacionamento ? rowData.pessoa_fisica.param_relacionamento.descr : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.nome_pai }}
                </td>
                <td v-if="rowData && rowData.pessoa_fisica">
                  {{ rowData.pessoa_fisica.nome_mae }}
                </td>
                <td v-if="rowData && rowData.pessoa_juridica">
                  {{ rowData.pessoa_juridica.nome_fantasia }}
                </td>
                <td v-if="rowData && rowData.pessoa_juridica">
                  {{ rowData.pessoa_juridica.inscricao_municipal }}
                </td>
                <td v-if="rowData && rowData.pessoa_juridica">
                  {{ rowData.pessoa_juridica.inscricao_suframa }}
                </td>
                <td v-if="rowData && rowData.pessoa_juridica">
                  {{ rowData.pessoa_juridica.cd_regime_tributario }}
                </td>
                <td>
                  {{ rowData && rowData.liv_tipo_cadastro ? rowData.liv_tipo_cadastro.descr : ''}}
                </td>
                <td>
                  {{ rowData && rowData.obs ? rowData.obs : '' }}
                </td>
                <td>
                  {{ rowData && rowData.liv_vip_nacional ? rowData.liv_vip_nacional.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.liv_vip_internacional ? rowData.liv_vip_internacional.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.cnae ? rowData.cnae.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.liv_indie ? rowData.liv_indie.descr : ''}}
                </td>
                <td>
                  {{ rowData && rowData.param_tipo_proprietario ? rowData.param_tipo_proprietario.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.liv_tp_fornecedor ? rowData.liv_tp_fornecedor.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.exige_averbacao ? rowData.exige_averbacao.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.valida_opentech ? rowData.valida_opentech.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.antt ? rowData.antt : '' }}
                </td>
                <td>
                  {{ rowData && rowData.dt_validade_antt ? formatDate(rowData.dt_validade_antt) : '' }}
                </td>
                <td v-if="rowData && rowData.pessoa_juridica">
                  {{ rowData.pessoa_juridica.cd_gestao_pagto }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_endereco && rowData.pessoa_endereco.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">CEP</th>
                <th style="width: 20%">Endereço</th>
                <th style="width: 10%">Bairro</th>
                <th style="width: 10%">Número</th>
                <th style="width: 10%">Complemento</th>
                <th style="width: 20%">Município</th>
                <th style="width: 10%">Tipo</th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in (rowData && rowData.pessoa_endereco ? rowData.pessoa_endereco : [])" :key="index">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ row.cep }}
                </td>
                <td>
                  {{ row.endereco }}
                </td>
                <td>
                  {{ row.bairro }}
                </td>
                <td>
                  {{ row.numero }}
                </td>
                <td>
                  {{ row.complemento }}
                </td>
                <td>
                  {{ row.municipio ? row.municipio.nome : '' }}
                </td>
                <td>
                  {{ row.parend ? row.parend.descr : ''}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_contato_email && rowData.pessoa_contato_email.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Email</th>
                <th style="width: 20%">Tipo de Cadastro</th>
                <th style="width: 20%">Principal</th>
                <th style="width: 20%">Tipo</th>
                <th style="width: 20%">Status</th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in (rowData && rowData.pessoa_contato_email ? rowData.pessoa_contato_email : [])" :key="index">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ row.email }}
                </td>
                <td>
                  {{ row.tipo_cadastro ? row.tipo_cadastro.descr : '' }}
                </td>
                <td>
                  {{ row.email_default ? row.email_default.descr : '' }}
                </td>
                <td>
                  {{ row.param_tipo_email ? row.param_tipo_email.descr : ''}}
                </td>
                <td>
                  {{ row.status ? row.status.descr : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_contato_tel && rowData.pessoa_contato_tel.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">DDD</th>
                <th style="width: 20%">Telefone</th>
                <th style="width: 20%">Tipo</th>
                <th style="width: 20%">Operadora</th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in (rowData && rowData.pessoa_contato_tel ? rowData.pessoa_contato_tel : [])" :key="index">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ row.ddd }}
                </td>
                <td>
                  {{ row.telefone }}
                </td>
                <td>
                  {{ row.tipo_tel ? row.tipo_tel.descr : '' }}
                </td>
                <td>
                  {{ row.partelope ? row.partelope.descr : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_financeiro &&  rowData.pessoa_financeiro.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Agência</th>
                <th style="width: 5%">Dígito</th>
                <th style="width: 20%">Nome Agência</th>
                <th style="width: 5%">Conta corrente</th>
                <th style="width: 5%">Dígito</th>
                <th style="width: 5%">Número da Conta</th>
                <th style="width: 20%">Banco</th>
                <th style="width: 15%">Método de pagamento</th>
                <th style="width: 10%">Prazo</th>
                <th style="width: 5%">Padrão ?</th>
                <th style="width: 5%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, index) in (rowData && rowData.pessoa_financeiro ? rowData.pessoa_financeiro : [])"
                :key="index"
              >
                <td>
                  {{ item.agencia }}
                </td>
                <td>
                  {{ item.agencia_digito }}
                </td>
                <td>
                  {{ item.agencia_nome }}
                </td>
                <td>
                  {{ item.conta_corrente }}
                </td>
                <td>
                  {{ item.conta_corrente_digito }}
                </td>
                <td>
                  {{ item.numero_acc }}
                </td>
                <td>
                  {{ item.param_banco ? item.param_banco.descr : '' }}
                </td>
                <td>
                  {{ item.param_forma_pagamento ? item.param_forma_pagamento.descr : '' }}
                </td>
                <td>
                  {{ item.prazo_pagamento }}
                </td>
                <td>
                  <span class="badge badge-success" v-if="item.is_padrao == 1"
                    >Sim</span
                  >
                  <span class="badge badge-danger" v-if="item.is_padrao == 2"
                    >Não</span
                  >
                </td>
                <td>
                  <span v-if="item.status">
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.regra_fiscal_cliente && rowData.regra_fiscal_cliente.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Código</th>
                <th style="width: 10%">Descrição</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, index) in (rowData.regra_fiscal_cliente && rowData.regra_fiscal_cliente.regra_fiscal ? rowData.regra_fiscal_cliente.regra_fiscal : [])" :key="index"
              >
                <td>
                  {{ item.cd }}
                </td>
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  <span v-if="item.status">
                    <span
                      class="badge badge-success"
                      v-if="item.status.valor == 1"
                      >{{ item.status.descr }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if="item.status.valor == 2"
                      >{{ item.status.descr }}</span
                    >
                  </span>
                </td>
                <td>
                  <span v-if="item.status">
                  <a
                    v-if="item.status.valor == 2"
                    @click="onActivateDesactivate(1, item, true)"
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1"
                    @click="onActivateDesactivate(2, item, true)"
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_fisica && rowData.pessoa_fisica.pessoa_motorista"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 15%">CNH</th>
                <th style="width: 15%">Num. registro CNH</th>
                <th style="width: 15%">Data de emissão CNH</th>
                <th style="width: 15%">Data de vencimento CNH</th>
                <th style="width: 15%">UF emissão</th>
                <th style="width: 10%">Categoria</th>
                <th style="width: 5%">Tipo de vínculo</th>
                <th style="width: 45%">Obs.</th>
                <th style="width: 5%">Código gestão de pagamento</th>
                <th style="width: 5%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.pessoa_fisica.pessoa_motorista.cnh }}
                </td>
                <td>
                  {{ rowData.pessoa_fisica.pessoa_motorista.num_registro_cnh }}
                </td>
                <td>
                  {{
                    formatDate(
                      rowData.pessoa_fisica.pessoa_motorista.dt_emissao_cnh
                    )
                  }}
                </td>
                <td>
                  {{
                    formatDate(
                      rowData.pessoa_fisica.pessoa_motorista.dt_vencimento_cnh
                    )
                  }}
                </td>
                <td>
                  {{ rowData.pessoa_fisica.pessoa_motorista.uf_emissao ? rowData.pessoa_fisica.pessoa_motorista.uf_emissao.cd : '' }}
                </td>
                <td>
                 {{ rowData.pessoa_fisica.pessoa_motorista.categoria ? rowData.pessoa_fisica.pessoa_motorista.categoria.descr : '' }}
                </td>
                <td>
                  {{ rowData.pessoa_fisica.pessoa_motorista.tp_vinculo ? rowData.pessoa_fisica.pessoa_motorista.tp_vinculo.descr : '' }}
                </td>
                <td>
                   {{ rowData.pessoa_fisica.pessoa_motorista.cd_gestao_pagto }}
                </td>
                <td>
                  {{ rowData.pessoa_fisica.pessoa_motorista.obs }}
                </td>
                <td>
                  <span v-if="rowData.pessoa_fisica.pessoa_motorista.status">
                    <span
                      class="badge badge-success"
                      v-if="
                        rowData.pessoa_fisica.pessoa_motorista.status.valor == 1
                      "
                      >{{
                        rowData.pessoa_fisica.pessoa_motorista.status.descr
                      }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if="
                        rowData.pessoa_fisica.pessoa_motorista.status.valor == 2
                      "
                      >{{
                        rowData.pessoa_fisica.pessoa_motorista.status.descr
                      }}</span
                    >
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_referencia && rowData.pessoa_referencia.length > 0"
        >
          <div v-for="(item, index) in (rowData && rowData.pessoa_referencia ? rowData.pessoa_referencia : [])" :key="index">
            <table class="table-striped" id="mais">
              <thead>
                <tr>
                  <th style="width: 20%">Nome</th>
                  <th style="width: 5%">DDD</th>
                  <th style="width: 10">Telefone</th>
                  <th style="width: 15%">E-mail</th>
                  <th style="width: 15%">Relação</th>
                  <th style="width: 15%">Município</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ item.nome }}
                  </td>
                  <td>({{ item.ddd }})</td>
                  <td>
                    {{ item.numero_tel }}
                  </td>
                  <td>
                    {{ item.email }}
                  </td>
                  <td>
                    {{ item.param_relacionamento ? item.param_relacionamento.descr : '' }}
                  </td>
                  <td>
                    {{ item.municipio ? item.municipio.nome : '' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="table-striped" id="mais">
              <thead>
                <tr>
                  <th style="width: 30%">Endereço</th>
                  <th style="width: 5%">Número</th>
                  <th style="width: 15%">Bairro</th>
                  <th style="width: 15%">Complemento</th>
                  <th style="width: 10%">CEP</th>
                  <th style="width: 5%">DDD 2</th>
                  <th style="width: 15%">Tel. 2</th>
                  <th style="width: 5%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    {{ item.endereco }}
                  </td>
                  <td>({{ item.numero }})</td>
                  <td>
                    {{ item.bairro }}
                  </td>
                  <td>
                    {{ item.complemento }}
                  </td>
                  <td>
                    {{ item.cep }}
                  </td>
                  <td>({{ item.ddd_2 }})</td>
                  <td>
                    {{ item.numero_2 }}
                  </td>
                  <td>
                    <span v-if="item.status">
                    <span
                      class="badge badge-success"
                      v-if="item.status.valor == 1"
                      >{{ item.status.descr }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if="item.status.valor == 2"
                      >{{ item.status.descr }}</span
                    >
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 6%">Venda de serviço</th>
                <th style="width: 5%">Gera Pré.Fat</th>
                <th style="width: 10%">Permite adiantamento</th>
                <th style="width: 10%">Controla Dt.entrega</th>
                <th style="width: 10%">Layout de Etiqueta</th>
                <th style="width: 10%">Indicador Edoccob</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData && rowData.status_venda_servico ? rowData.status_venda_servico.descr : '' }}
                </td>
                <td>
                 {{ rowData && rowData.liv_gerar_pre_fatura ? rowData.liv_gerar_pre_fatura.descr : '' }}
                </td>
                <td>
                 {{ rowData && rowData.permitir_adiantamento ? rowData.permitir_adiantamento.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.liv_controla_dt_entrega ? rowData.liv_controla_dt_entrega.descr : '' }}
                </td>
                <td>
                 {{ rowData && rowData.b_etiqueta_layout ? rowData.b_etiqueta_layout.descr : '' }}
                </td>
                <td>
                 {{ rowData && rowData.edoccob ? rowData.edoccob.descr : '' }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Grupo Econômico Edoccob</th>
                <th style="width: 10%">Prazo Edoccob</th>
                <th style="width: 10%">Qtde de reentregas</th>
                <th style="width: 10%">Parâmetro de Retira</th>
                <th style="width: 10%">Doc. Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData && rowData.pessoa_juridica_grupo_economico ? rowData.pessoa_juridica_grupo_economico.razao_social : '' }}
                  {{ rowData && rowData.pessoa_fisica_grupo_economico ? rowData.pessoa_fisica_grupo_economico.nome : '' }}
                  {{ rowData && rowData.pessoa_exterior_grupo_economico ? rowData.pessoa_exterior_grupo_economico.nome : '' }}
                </td>
                <td>
                  {{ rowData && rowData.prazo_edoccob ? rowData.prazo_edoccob.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.qtde_reentrega ? rowData.qtde_reentrega : '' }}
                </td>
                <td>
                  {{ rowData && rowData.retira ? rowData.retira.descr : '' }}
                </td>
                <td>
                  {{ rowData && rowData.doc_pagamento ? rowData.doc_pagamento.descr : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t10' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_ajudante"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Código gestão de pagamento</th>
                <th style="width: 10%">Código gerenciamento de risco</th>
                <th style="width: 10%">
                  Código de pesquisa gerenciamento de risco
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.pessoa_ajudante.cd_gestao_pagto }}
                </td>
                <td>
                  {{ rowData.pessoa_ajudante.cd_gerenciamento_risco }}
                </td>
                <td>
                  {{ rowData.pessoa_ajudante.cdpesquisa_gerenciamento_risco }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t12' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Descrição</th>
                <th style="width: 10%">Tipo erro</th>
                <th style="width: 60%">XML</th>
                <th style="width: 10%">Data</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, index) in (rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro ? rowData.pessoa_ajudante.pessoa_ajudante_ger_risco_erro : [])"
                :key = "index"
              >
                <td>
                  {{ item.descr }}
                </td>
                <td>
                 <span v-if="item.tp_erro">
                    <span
                      class="badge badge-success"
                      v-if="item.tp_erro.valor == 1"
                      >{{ item.tp_erro.descr }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if="item.tp_erro.valor == 2"
                      >{{ item.tp_erro.descr }}</span
                    >
                    <span
                      class="badge badge-info"
                      v-if="item.tp_erro.valor == 3"
                      >{{ item.tp_erro.descr }}</span
                    >
                  </span>
                </td>
                <td>
                  {{ item.xml }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_inc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t11' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 3%">Código ajudante</th>
                <th style="width: 12%">Nome</th>
                <th style="width: 20%">Situação</th>
                <th style="width: 5%">Tipo situação</th>
                <th style="width: 5%">Data consulta</th>
                <th style="width: 5%">Data expiração</th>
                <th style="width: 4%">Senha</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, index) in (rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_ger_risco ?  rowData.pessoa_ajudante.pessoa_ajudante_ger_risco : [])"
                :key="index"
              >
                <td>
                  {{ item.cd_pfj }}
                </td>
                <td>
                  {{ item.nome }}
                </td>
                <td>
                  {{ item.situacao }}
                </td>
                <td>
                  {{ item.tp_situacao ? item.tp_situacao.descr : '' }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_consulta) }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_expiracao) }}
                </td>
                <td>
                  {{ item.senha }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t13' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_foto && rowData.pessoa_ajudante.pessoa_ajudante_foto.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 2%">N° da foto</th>
                <th style="width: 15%">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in (rowData && rowData.pessoa_ajudante && rowData.pessoa_ajudante.pessoa_ajudante_foto ? rowData.pessoa_ajudante.pessoa_ajudante_foto : [])"
                 :key="i"
              >
                <td>
                  {{ i + 1 }}
                </td>
                <td>
                  <a
                    @click="goLink(item.url_foto)"
                    target="_blank"
                    onMouseOver="this.style.color='#404E67'"
                    onMouseOut="this.style.color='#0097e6'"
                  >
                    {{ item.nome_foto ? item.nome_foto : item.url }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t15' + (rowData && rowData.pessoa_id ? rowData.pessoa_id : '')"
          v-if="rowData && rowData.integracao_log && rowData.integracao_log.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 80%">Descrição</th>
                <th data-toggle="true" style="width: 3%">Qtde</th>
                <th data-toggle="true" style="width: 10%">
                  Data Primeira e Ultima Ocorrencia
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in (rowData && rowData.integracao_log ? rowData.integracao_log : [])" :key="i"
              >
                <td>
                  <span v-if="item.integracao != null" class="badge badge-primary">{{
                    item.integracao.descr
                  }}</span>
                  <br v-if="item.integracao != null" />
                  {{ item.descr }}
                </td>
                <td>
                  {{ item.qtde }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_primeira_ocorrencia) }}<br />
                  {{ formatDateHora(item.dt_ultima_ocorrencia) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({ id: data.regfis_id, status: action });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }

      this.helpForm
        .post("/api/regrafiscal/status")
        .then((response) => {
          new ReturnApi(response, this);
          Event.$emit("reloadVuetable", data);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    goLink(data) {
      window.open(data, "_blank");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value).format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null ? "" : moment(value).format(fmt);
    },
  },
};
</script>